import {ExpenseDao} from '../../dao';
import {
    ErrorModel
} from '../../models';
import {SERVICE_CODE} from './_serviceCode';
const FUNCTION_CODE = 'DELETE_EXPENSE';

export async function deleteExpense(
    userData: Record<string, string>,
    expenseId: string
) {
    try {
        const result = await ExpenseDao.deleteExpense(userData.userToken, expenseId);

        return result;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${SERVICE_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la suppression d\'un frais',
            error: error
        });
    }
}
